<template>
    
    <div class="section">
      <div class="container text-center p-0">
        <div class="row m-0 justify-content-md-center">
          <div class="col-md-12 col-lg-6 background-consultancy row m-0">
            <h3 class="title col-12">Consultoria em nuvem<label>.</label></h3>
            <h6 class="description  col-6 col-lg-4">
                Onde quer que você esteja na sua jornada nas nuvens, 
                nós podemos ajudar<label>.</label>
            </h6> 
          </div>
          <div class="col-md-12 col-lg-6 background-courses row m-0">
            <h3 class="title col-12">
                Treinamentos de Tecnologia<label>.</label>
            </h3>
            <h6 class="description col-6 col-lg-4 text-right">
                Treinamentos curtos, objetivos e planejados
                para acelerar sua entrada no mercado 
                de trabalho<label>.</label>
            </h6>          
          </div>
        </div>
      </div>
    </div>

</template>

<script>

export default {
    name: 'overview-section'
}
</script>

<style scoped lang="scss">

.section {
    background-color: #ecf0f1;

    .background-consultancy {
        background-image: url(https://bucket-ctcloud.s3.sa-east-1.amazonaws.com/trainings.webp);
        background-position: 25% center;
        background-size: cover;
        height: 90vh;
        align-content: space-between;

        .title {
            color: #000;
        }

        .description {
            color: #000;
            text-align: left;
            padding: 30px;
            font-weight: 900;

        }
    }

    .background-courses {
        background-image: url(https://bucket-ctcloud.s3.sa-east-1.amazonaws.com/consultancy.webp);
        background-position: center center;
        background-size: cover;
        height: 90vh;
        align-content: space-between;
        justify-content: flex-end;

        .title {
            color: #fff;
        }

        .description {
            color: #fff;
            text-align: left;
            padding: 30px;
            font-weight: 900;
        }
    }
}





</style>
